<template>
<v-navigation-drawer permanent class="onboarding navDrawer" width="242">
  <div v-if="summary" class="navContainer">
    <section v-for="(s,i) of orgItems" :key="i">
      <header>{{s.header}}</header>
      <div v-for="(ni,i) of s.items" :key="i">
        <div class="navItem" v-bind:class="[ni.status]">
          <div class="statusIcon"></div>
          <router-link class="label" :to="ni.path">
            <label>{{ni.label}}</label>
          </router-link>
        </div>
        <div v-if="i < (s.items.length-1)" class="dashed-line" :class="[ni.status]"></div>
      </div>
    </section>
    <section v-for="(s,i) of leItems" :key="i">
      <header>{{s.header}}</header>
      <div v-for="(ni,i) of s.items" :key="i">
        <div class="navItem" v-bind:class="[ni.status]">
          <div class="statusIcon"></div>
          <router-link class="label" :to="ni.path">
            <label>{{ni.label}}</label>
          </router-link>
        </div>
        <div v-if="i < (s.items.length-1)" class="dashed-line" :class="[ni.status]"></div>
      </div>
    </section>
    <section v-for="(s,i) of buItems" :key="i">
      <header>{{s.header}}</header>
      <div v-for="(ni,i) of s.items" :key="i">
        <div class="navItem" v-bind:class="[ni.status]">
          <div class="statusIcon"></div>
          <router-link class="label" :to="ni.path">
            <label>{{ni.label}}</label>
          </router-link>
        </div>
        <div v-if="i < (s.items.length-1)" class="dashed-line" :class="[ni.status]"></div>
      </div>
    </section>
    <section v-for="(s,i) of buTypeItems" :key="i">
      <header>{{s.header}}</header>
      <div v-for="(ni,i) of s.items" :key="i">
        <div class="navItem" v-bind:class="[ni.status]">
          <div class="statusIcon"></div>
          <router-link class="label" :to="ni.path">
            <label>{{ni.label}}</label>
          </router-link>
        </div>
        <div v-if="i < (s.items.length-1)" class="dashed-line" :class="[ni.status]"></div>
      </div>
    </section>
  </div>
</v-navigation-drawer>
</template>
<script>
import {
  eventBus
} from '@/main';
export default {
  name: "orgSummaryNavDrawer",
  data() {
    return {
      summary: true,
      orgItems: [{
        type: "section",
        header: "Organisation",
        items: [{
            type: "navitem",
            label: "Organisation Info",
            status: "pending",
            path: "/onboard"
          }],
        }],
        leItems: [{
        type: "section",
        header: "Legal Entity",
        items: [{
            type: "navitem",
            label: "Legal Entity Info",
            status: "pending",
            path: "/onboard/legal"
          }],
        }],
        buItems: [{
        type: "section",
        header: "Business Units",
        items: [{
            type: "navitem",
            label: "List of all business units",
            status: "pending",
            path: "/onboard/business"
          }],
        }],
        buTypeItems: [{
        type: "section",
        header: "Business Unit Types",
        items: [{
            type: "navitem",
            label: "List of all business unit types",
            status: "pending",
            path: "/onboard/buTypes"
          }],
        }],
    };
  },
  created() {
    eventBus.$on('goToLocations', this.changeNavDrawer);
    eventBus.$on('updateNavDrawer', this.updateNavDrawer);
  },
  methods: {
    updateView(view) {
      this.$emit("updateView", view);
    },
    goToSummary() {
      this.summary = true;
      this.$router.push('/onboard/summary');
    },
    changeNavDrawer() {
      this.summary = false;
    },
    updateNavDrawer(data) {
      let items = this.summaryItems[0].items;
      let i;
      for (i = 0; i < items.length; i++) {
        if (items[i].label === data) {
          items[i].status = 'complete';
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.router-link-exact-active {
    &.label {
        color: #000000;
        font-weight: bold;
    }
}
%circle {
    background-color: white !important;
    border: 1px solid #303030;
    height: 12px;
    width: 12px;
    min-width: 0;
    border-radius: 50%;
}

%circle-filled {
    height: 14px;
    width: 14px;
}

.dashed-line {
    height: 25px;
    border-left: 1px dashed #b0b0b0;
    margin-left: 5px;
    margin-top: 2px;
    margin-bottom: 2px;
}

.onboarding {
    font-family: Montserrat;
    position: relative;
    height: 100%;
    .navContainer {
        width: 242px;
        position: relative;
        display: block;
        padding-left: 32px;
        padding-top: 32px;
        font-size: 14px;

        section {
            padding-bottom: 16px;
            margin-bottom: 26px;

            header {
                font-size: 12px;
                padding-bottom: 10px;
            }

            .dashed-line {
                height: 25px;
                border-left: 1px dashed #b0b0b0;
                margin-left: 5px;
                margin-bottom: 4px;
                &.complete {
                    border-color: #5d409f;
                }
                &.incomplete {
                    border-color: #a41010;
                }
            }

            .navItem {
                display: flex;
                align-items: center;

                .statusIcon {
                    margin-right: 10px;
                }

                .label {
                    text-decoration: none;
                    color: black;
                    font-size: 14px !important;
                }

                &.pending {
                    .statusIcon {
                        @extend %circle;
                    }
                }

                &.active {
                    a.label {
                        color: #000000;
                        font-weight: bold;
                    }

                    .statusIcon {
                        @extend %circle;
                    }
                }

                // &.complete {
                //     a.label {
                //         color: #5d409f;
                //     }

                //     .statusIcon {
                //         @extend %circle-filled;
                //         background-image: url("../assets/group-9.png");
                //     }
                // }

                // &.incomplete {
                //     .statusIcon {
                //         @extend %circle-filled;
                //         background-image: url("../assets/group-15.svg");
                //     }
                // }
            }
        }
    }
    // .navItem {}
}

.navDrawer {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.1);
    background-color: #f9f9f9;
    width: 242px;
    float: left;
    height: calc(100vh - 66px);
}

.sub-header {
    color: #34c0be;
    margin: 30px 0 5px 30px;
    font-weight: lighter;
}
.theme--light.v-stepper {
    background: none;
}
.v-stepper__step {
    padding: 5px 5px 5px 30px;
}
</style>
